import gql from "graphql-tag";
import { taskServiceTypeDef } from "../definitions/task-service-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const draftToCalculationMutation = gql`
  mutation draftToCalculation(
  $taskId: String!
  ){
    task{
      toNew(input: {
        taskId: $taskId
      }){
        output {
          ${taskServiceTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }

  }
`;

export default draftToCalculationMutation;
